import React from 'react';
import CategoriesQualityRoute from '../../features/categories-quality/CategoriesQualityRoute';

const CategoriesQualityHub: React.FC<{ className?: string }> = ({ className = '' }) => {
  return <CategoriesQualityRoute className={className} />;
};

export default CategoriesQualityHub;
